/**
 * Nymia · Landing / Creator page — STRUCTURAL constants only.
 *
 * ─────────────────────────────────────────────────────────────────────
 * All copy strings now live in the i18n resources:
 *   - /app/frontend/src/i18n/locales/{it,en}/landing.json
 *   - /app/frontend/src/i18n/locales/{it,en}/creator_page.json
 *
 * This file keeps ONLY the pieces that are NOT translation-friendly:
 *   • Icon component identifiers (`Heart`, `Radio`, …) resolved at the
 *     call-site via a lucide-react lookup map.
 *   • Image asset keys (`imgKey`) resolved via `landingImages.js`.
 *   • Test IDs used by Playwright / testing agents.
 *
 * The order of items here is authoritative: JSON translations must
 * expose arrays of matching length so the component can zip icon +
 * label at render time.
 * ─────────────────────────────────────────────────────────────────────
 */

// ═══════════════════════════════════════════════════════════════════════
//  LANDING HOME  (nymia.me/)
// ═══════════════════════════════════════════════════════════════════════
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.emergent.audiovideolive.cnhsba';

export const LANDING_STRUCTURE = {
  why: {
    cards: [
      { icon: 'Users',         testid: 'why-real-people' },
      { icon: 'MessageCircle', testid: 'why-talk-free' },
      { icon: 'Radio',         testid: 'why-lives' },
      { icon: 'EyeOff',        testid: 'why-no-show' },
    ],
  },
  experience: {
    cards: [
      { icon: 'Users',         testid: 'exp-people', screen: 'people' },
      { icon: 'MessageCircle', testid: 'exp-talk', screen: 'chat' },
      { icon: 'Radio',         testid: 'exp-live-audio', screen: 'live' },
      { icon: 'Mic',           testid: 'exp-voce-pro', screen: 'pro' },
    ],
  },
  daily: {
    cols: [
      { imgKey: 'dailyCooking', testid: 'daily-cooking' },
      { imgKey: 'dailyCar',     testid: 'daily-car' },
      { imgKey: 'dailyHome',    testid: 'daily-home' },
    ],
  },
  safety: {
    items: [
      { icon: 'Lock',           testid: 'safety-privacy' },
      { icon: 'HeartHandshake', testid: 'safety-environment' },
      { icon: 'LifeBuoy',       testid: 'safety-support' },
    ],
  },
};

// ═══════════════════════════════════════════════════════════════════════
//  CREATOR PAGE  (nymia.me/creator)
// ═══════════════════════════════════════════════════════════════════════
export const CREATOR_STRUCTURE = {
  build: {
    items: [
      { icon: 'Mic',           testid: 'build-podcast' },
      { icon: 'Radio',         testid: 'build-live' },
      { icon: 'ShoppingBag',   testid: 'build-marketplace' },
      { icon: 'Lock',          testid: 'build-premium' },
      { icon: 'Repeat',        testid: 'build-subs' },
      { icon: 'CalendarDays',  testid: 'build-booking' },
      { icon: 'Users',         testid: 'build-community' },
      { icon: 'MessageCircle', testid: 'build-chat' },
      { icon: 'Heart',         testid: 'build-tip' },
      { icon: 'Gift',          testid: 'build-donations' },
      { icon: 'Wallet',        testid: 'build-wallet' },
      { icon: 'BarChart3',     testid: 'build-dashboard' },
    ],
  },
};

export default { LANDING_STRUCTURE, CREATOR_STRUCTURE };
